/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advanced_DataInputs */

const en_advanced_data = /** @type {(inputs: Advanced_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus Data Analysis`)
};

const ar_advanced_data = /** @type {(inputs: Advanced_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحليل بيانات التركيز`)
};

const de_advanced_data = /** @type {(inputs: Advanced_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fokus Datenanalyse`)
};

const es_advanced_data = /** @type {(inputs: Advanced_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis de datos de concentración`)
};

const fr_advanced_data = /** @type {(inputs: Advanced_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse de votre concentration`)
};

const it_advanced_data = /** @type {(inputs: Advanced_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi dei dati di concentrazione`)
};

const ja_advanced_data = /** @type {(inputs: Advanced_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中データ分析`)
};

const ko_advanced_data = /** @type {(inputs: Advanced_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 데이터 분석`)
};

const pt_br_advanced_data = /** @type {(inputs: Advanced_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise dos dados de foco`)
};

const ru_advanced_data = /** @type {(inputs: Advanced_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анализ данных фокусировки`)
};

const th_advanced_data = /** @type {(inputs: Advanced_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การวิเคราะห์ข้อมูลการโฟกัส`)
};

const tr_advanced_data = /** @type {(inputs: Advanced_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanma Veri Analizi`)
};

const zh_cn_advanced_data = /** @type {(inputs: Advanced_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专注数据分析`)
};

const zh_tw_advanced_data = /** @type {(inputs: Advanced_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專注數據分析`)
};

/**
* | output |
* | --- |
* | "Focus Data Analysis" |
*
* @param {Advanced_DataInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const advanced_data = /** @type {((inputs?: Advanced_DataInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advanced_DataInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_advanced_data(inputs)
	if (locale === "ar") return ar_advanced_data(inputs)
	if (locale === "de") return de_advanced_data(inputs)
	if (locale === "es") return es_advanced_data(inputs)
	if (locale === "fr") return fr_advanced_data(inputs)
	if (locale === "it") return it_advanced_data(inputs)
	if (locale === "ja") return ja_advanced_data(inputs)
	if (locale === "ko") return ko_advanced_data(inputs)
	if (locale === "pt_br") return pt_br_advanced_data(inputs)
	if (locale === "ru") return ru_advanced_data(inputs)
	if (locale === "th") return th_advanced_data(inputs)
	if (locale === "tr") return tr_advanced_data(inputs)
	if (locale === "zh_cn") return zh_cn_advanced_data(inputs)
	return zh_tw_advanced_data(inputs)
});